<ul [class.breadcrumb]="useBootstrap" class="surface-0">
  <li class="breadcrumb-item"><a role="button" (click)="navigateTo('/dashboard')"><i class="fa fa-home" aria-hidden="false" style="font-size: 25px"></i></a></li>
  <li *ngFor="let url of _urls; let last = last" [class]="{'breadcrumb-item': useBootstrap, 'active': last}">
    <div class="breadcrumb-arrow"><i class="fa fa-chevron-right"></i></div>
    <!-- disable link of last item -->
    <a role="button" *ngIf="!last && url == prefix" (click)="navigateTo(url)"><i class="fa fa-home"></i></a>
    <a role="button" *ngIf="!last && url != prefix" (click)="navigateTo(url)">{{friendlyName(url)}}</a>
    <a *ngIf="last && url == prefix"><i class="fa fa-home"></i></a>
    <a *ngIf="last && url != prefix">{{friendlyName(url)}}</a>
  </li>
</ul>
